import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { FormGroup } from "@angular/forms/src/model";
import { Validators } from "@angular/forms";
import { Router } from "@angular/router";
import "rxjs/add/operator/map";
import "rxjs/add/operator/debounceTime";
import { SearchService } from "../../service/search.service";

@Component({
  selector: "app-search",
  templateUrl: "./search.component.html",
  styleUrls: ["./search.component.css"]
})
export class SearchComponent implements OnInit {
  notFound: boolean = false;

  constructor(
    private _router: Router,
    private _location: Location,
    public _searchService: SearchService
  ) { }

  ngOnInit() { }

  doSearch(val) {
    if (val) {
      this._searchService.searchImmat(val).then(result => {
        if (result)
          this._router.navigate(["/tchek/detail", result.id]);
        else
          this.notFound = true;
      });
    }
  }

  setNotFound(e) {
    if (e.keyCode != 13) this.notFound = false;
  }

  // Méthode de retour à la page précédente
  back() {
    this._location.back();
  }
}



// WEBPACK FOOTER //
// ./src/app/element/search/search.component.ts